import { renderEntityCreated as renderDefaultEntityCreated } from '@core/audit/renderers/entityCrud';
import {
  type AuditLogRenderer,
  formatAuditSubjectDescription,
} from '@core/utils/auditLog';
import { HistoryLines } from '../HistoryLines';
import {
  historySubject,
  isVestmentItemType,
  readHistoryColor,
  vestmentAction,
} from '../historyLabel';

export const renderEntityCreated: AuditLogRenderer = (entry) => {
  if (entry.subjectType === 'Order') {
    return <>Order created</>;
  }

  if (isVestmentItemType(entry.subjectType)) {
    return (
      <HistoryLines
        title={historySubject(entry)}
        action={vestmentAction(
          entry.subjectType,
          'Added',
          Boolean(entry.metadata?.queuedForPrint)
        )}
        color={readHistoryColor(entry)}
      />
    );
  }

  if (entry.metadata?.queuedForPrint) {
    const { typeLabel, idPart } = formatAuditSubjectDescription(entry);
    return (
      <>
        {typeLabel}
        {idPart} created and queued for printing
      </>
    );
  }

  return renderDefaultEntityCreated(entry);
};
